// extracted by mini-css-extract-plugin
export default {"Article":"GameArticle-module__Article__j457H","Byline":"GameArticle-module__Byline__U8LDO"};